<app-shared-layout Analysis="Reports" [hideAdd]="true">
  <div ngProjectAs="primary-panel">
 
    <div class="rounded-tab centered flex p-1.5 rounded-lg w-fit gap-2">
      <ng-container *ngFor="let tab of reportTabs">
        <button
          (click)="activeReportTab = tab.slug"
          [ngClass]="{
            'bg-blue-300 text-white ring-1 ring-blue-600':
              tab.slug === 'warehouse' && activeReportTab === tab.slug,
            'bg-blue-100 text-blue-800 hover:bg-blue-200':
              tab.slug === 'warehouse' && activeReportTab !== tab.slug,

            'bg-green-500 text-white ring-1 ring-green-700':
              tab.slug === 'single-warehouse' && activeReportTab === tab.slug,
            'bg-green-100 text-green-800 hover:bg-green-200':
              tab.slug === 'single-warehouse' && activeReportTab !== tab.slug,

            'bg-yellow-500 text-white ring-1 ring-yellow-600':
              tab.slug === 'env-summary' && activeReportTab === tab.slug,
            'bg-yellow-100 text-yellow-800 hover:bg-yellow-200':
              tab.slug === 'env-summary' && activeReportTab !== tab.slug,

            'bg-purple-500 text-white ring-1 ring-purple-600':
              tab.slug === 'sensor' && activeReportTab === tab.slug,
            'bg-purple-100 text-purple-800 hover:bg-purple-200':
              tab.slug === 'sensor' && activeReportTab !== tab.slug,

            'bg-indigo-500 text-white ring-1 ring-indigo-700':
              tab.slug === 'building' && activeReportTab === tab.slug,
            'bg-indigo-100 text-indigo-800 hover:bg-indigo-200':
              tab.slug === 'building' && activeReportTab !== tab.slug,

            'bg-red-500 text-white ring-1 ring-red-700':
              tab.slug === 'alert' && activeReportTab === tab.slug,
            'bg-red-100 text-red-800 hover:bg-red-200':
              tab.slug === 'alert' && activeReportTab !== tab.slug,

            'bg-teal-500 text-white ring-1 ring-teal-700':
              tab.slug === 'coldroom' && activeReportTab === tab.slug,
            'bg-teal-100 text-teal-800 hover:bg-teal-200':
              tab.slug === 'coldroom' && activeReportTab !== tab.slug
          }"
          class="rounded-tab-list flex items-center gap-2 px-3 py-2 font-medium transition-all duration-300 rounded-lg"
        >
          <img [src]="tab?.icon" alt="" class="w-5 h-5" />
          {{ tab?.name }}
        </button>
      </ng-container>
    </div>

 
    <div class="-mt-1">
      <app-warehouse-report
        *ngIf="activeReportTab === 'warehouse'"
      ></app-warehouse-report>
      <app-warehouse-report
        *ngIf="activeReportTab === 'single-warehouse'"
        [isAllWarehouse]="false"
      ></app-warehouse-report>
      <app-environment-summary-report
        *ngIf="activeReportTab === 'env-summary'"
      ></app-environment-summary-report>
      <app-sensor-performance-report
        *ngIf="activeReportTab === 'sensor'"
      ></app-sensor-performance-report>
      <app-building-analysis-report
        *ngIf="activeReportTab === 'building'"
      ></app-building-analysis-report>
      <app-alert-report *ngIf="activeReportTab === 'alert'"></app-alert-report>
      <app-coldroom-report *ngIf="activeReportTab === 'coldroom'"></app-coldroom-report>
    </div>
  </div>
</app-shared-layout>
